// src/pages/Appli/AppliAdmin/clubs-admin/components/ClubsFiltersBar.jsx

import React from "react";

import {
  FaPlus,
  FaSearch,
  FaTimes,
} from "react-icons/fa";

export default function ClubsFiltersBar({
  searchTerm,
  setSearchTerm,

  departements,
  selectedDepartement,
  setSelectedDepartement,

  hasActiveFilters,
  onReset,
  onCreate,

  loading,
}) {
  return (
    <section className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="grid gap-3 xl:grid-cols-[minmax(300px,1fr)_240px_auto_auto]">
        <label className="relative block">
          <span className="sr-only">Rechercher un club</span>

          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-sm text-slate-400" />

          <input
            type="search"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Rechercher un club, une ville, un numéro…"
            className="h-11 w-full rounded-2xl border border-slate-300 bg-white pl-11 pr-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500"
          />
        </label>

        <label>
          <span className="sr-only">Filtrer par département</span>

          <select
            value={selectedDepartement}
            onChange={(event) =>
              setSelectedDepartement(event.target.value)
            }
            className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          >
            <option value="">Tous les départements</option>

            {departements.map((departement) => (
              <option key={departement} value={departement}>
                Département {departement}
              </option>
            ))}
          </select>
        </label>

        <button
          type="button"
          onClick={onReset}
          disabled={!hasActiveFilters || loading}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaTimes />
          Réinitialiser
        </button>

        <button
          type="button"
          onClick={onCreate}
          className="inline-flex h-11 items-center justify-center gap-2 rounded-2xl bg-indigo-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700"
        >
          <FaPlus />
          Ajouter un club
        </button>
      </div>
    </section>
  );
}